module.exports = __webpack_public_path__ + "static/media/ICT-5.4765dc39.png";